// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CodeFilledSvg from "@fishx/icons-svg/es/asn/CodeFilled";
import FishxIcon from '../components/FishxIcon';

var CodeFilled = function CodeFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: CodeFilledSvg
  }));
};

CodeFilled.displayName = 'CodeFilled';
export default React.forwardRef(CodeFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/CodeFilled.js
// module id = 2261
// module chunks = 0